//
//
//
//

export default {
  props: {
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}
